/**
 * Sequence definition types for nurture automation
 */

export interface SequenceStep {
  step_number: number;
  delay_minutes: number;
  channel: 'sms' | 'email';
  template_name: string;
  template_content?: {
    sms_text?: string;
    email_subject?: string;
    email_body?: string;
  };
}

export interface SequenceDefinition {
  id: string;
  name: string;
  description?: string;
  trigger?: string;
  active: boolean;
  steps: SequenceStep[];
  created_at?: string;
  updated_at?: string;
}

export interface SequenceDefinitionListItem {
  id: string;
  name: string;
  description?: string;
  trigger?: string;
  active: boolean;
  steps_count: number;
}

export interface SequenceDefinitionCreate {
  name: string;
  description?: string;
  trigger?: string;
  active: boolean;
  steps: Omit<SequenceStep, 'step_number'>[];
}

export interface SequenceDefinitionUpdate {
  name?: string;
  description?: string;
  trigger?: string;
  active?: boolean;
  steps?: SequenceStep[];
}

// Available triggers for auto-start
export const SEQUENCE_TRIGGERS = [
  { value: 'meta_lead_no_booking', label: 'Meta Lead (No Booking)' },
  { value: 'inbound_no_response', label: 'Inbound Lead (No Response)' },
  { value: 'post_call_followup', label: 'Post-Call Follow-up' },
  { value: 'manual', label: 'Manual Enrollment Only' },
] as const;

// Template variables available
export const TEMPLATE_VARIABLES = [
  { variable: '{name}', description: 'Lead first name' },
  { variable: '{booking_link}', description: 'Booking page URL with tracking' },
  { variable: '{company}', description: 'Company name' },
] as const;
